export default "__VITE_ASSET__BzJO0zey__"